import { useAuth } from '@/contexts/auth-context';
import { BuildHistoryPanel } from '@/components/shared/build-history-panel';
import { PageHeader, PageSection } from '@/components/layouts/page-layout';

export function BuildHistoryPage() {
  const { user } = useAuth();
  const tenant = user?.tenant;

  if (!tenant) {
    return <div className="text-destructive">Tenant not found</div>;
  }

  return (
    <>
      <PageHeader
        title="Build History"
        description="View the complete build history for your website"
      />
      <PageSection>
        <BuildHistoryPanel
          tenantSlug={tenant.slug}
          title="Build History"
          description="View the complete build history for your website"
        />
      </PageSection>
    </>
  );
}
